module.exports = __webpack_public_path__ + "static/img/blue_limi.6d290ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video/pk/blue_limi.png
// module id = vcta
// module chunks = 1